"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetValues = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _reactRedux = require("react-redux");
var _react = require("react");
var _devices = require("../../../entities/devices");
var _user = require("../../../entities/user");
var _functions = require("../../../utils/functions");
var _webSockets = require("../webSockets");
var _constants = require("../../../utils/constants");
var _sites = require("../../../entities/sites");
const logPrefix = "".concat(_constants.packageKey.toUpperCase(), "::V");
const hideLogs = false;
const useGetValues = _ref => {
  let {
    socketId,
    baseUrl
  } = _ref;
  const [mustBeOpen, setMustBeOpen] = (0, _react.useState)(false);
  const equipmentSocketId = "".concat(socketId, "_equipment");
  const activeSiteId = (0, _reactRedux.useSelector)(_sites.selectActiveSiteId);
  const token = (0, _reactRedux.useSelector)(_user.selectToken);
  const dispatch = (0, _reactRedux.useDispatch)();
  const equipmentIds = (0, _reactRedux.useSelector)(_devices.selectEquipmentIds, _functions.areEqual);
  const {
    socket,
    readyState
  } = (0, _webSockets.useConnectInit)({
    mustBeOpen,
    socketId: equipmentSocketId,
    baseUrl,
    logPrefix,
    hideLogs
  });
  const connectionIsOpen = readyState === _webSockets.readyStates.OPEN;
  (0, _react.useEffect)(() => {
    setMustBeOpen(Boolean(activeSiteId));
  }, [activeSiteId]);
  (0, _react.useEffect)(() => {
    if (token && equipmentIds.length) {
      dispatch((0, _devices.getValuesAction)({
        ids: equipmentIds
      }));
    }
  }, [equipmentIds, token, dispatch]);
  (0, _react.useEffect)(() => {
    if (token && connectionIsOpen && socket && equipmentIds.length) {
      dispatch((0, _devices.getValueAction)({
        socket,
        ids: equipmentIds
      }));
    }
  }, [token, connectionIsOpen, dispatch, equipmentIds, socket]);
};
exports.useGetValues = useGetValues;